import React from 'react'

export interface IEntityFormValidationContext {
  entity: any
  errors: any
  hasSubmitted: boolean
  uiErrors?: Record<string, string[]>
  uiErrorLabels?: Record<string, string>
}

const defaultValue: IEntityFormValidationContext = {
  entity: null,
  errors: null,
  hasSubmitted: false,
  uiErrors: {},
  uiErrorLabels: {},
}

export const EntityFormValidationContext =
  React.createContext<IEntityFormValidationContext>(defaultValue)
